module.exports = __webpack_public_path__ + "static/img/follow.bc34c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/follow.png
// module id = ptEB
// module chunks = 1